"use client";

import { c as _c } from "react/compiler-runtime";
import type { PortableText as PortableTextType } from "@/sanity/sanity.types";
import { PortableText } from "next-sanity";
import InternalLink from "@/components/common/internal-link";
interface ICardDescriptionProps {
  description?: string | PortableTextType;
  className?: string;
}
const CardDescription = props => {
  const $ = _c(6);
  const {
    description,
    className: t0
  } = props;
  const className = t0 === undefined ? "" : t0;
  if (!description) {
    return null;
  }
  if (typeof description === "string") {
    const t1 = `${className} text-base font-normal`;
    let t2;
    if ($[0] !== description || $[1] !== t1) {
      t2 = <p className={t1}>{description}</p>;
      $[0] = description;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  } else {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        types: {
          undefined: _temp2
        },
        marks: {
          unknownMark: _temp3,
          internalLink: _temp4
        }
      };
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== description) {
      t2 = <PortableText onMissingComponent={_temp} value={description} components={t1} />;
      $[4] = description;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
};
export default CardDescription;
function _temp() {
  return null;
}
function _temp2() {
  return null;
}
function _temp3() {
  return null;
}
function _temp4(t0) {
  const {
    children,
    value
  } = t0;
  return <InternalLink value={value}>{children}</InternalLink>;
}